var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "form",
                            staticStyle: { padding: "10px" },
                            attrs: { model: _vm.form, inline: true }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "差异单号",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.form.check_record_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "check_record_id", $$v)
                                    },
                                    expression: "form.check_record_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "包裹号",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.form.package_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "package_no", $$v)
                                    },
                                    expression: "form.package_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      clearable: "",
                                      multiple: "",
                                      "multiple-limit": 10,
                                      placeholder: "包裹类型"
                                    },
                                    model: {
                                      value: _vm.form.package_type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "package_type", $$v)
                                      },
                                      expression: "form.package_type"
                                    }
                                  },
                                  _vm._l(_vm.options.package_type, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        value: item.value,
                                        label: item.label
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { staticClass: "_form-item" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      clearable: "",
                                      remote: "",
                                      "remote-method": _vm.fetchSupply,
                                      placeholder: "商家"
                                    },
                                    model: {
                                      value: _vm.form.supply_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "supply_id", $$v)
                                      },
                                      expression: "form.supply_id"
                                    }
                                  },
                                  _vm._l(_vm.options.supply, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        value: item.value,
                                        label: item.label
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      clearable: "",
                                      placeholder: "市场"
                                    },
                                    model: {
                                      value: _vm.form.market_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "market_id", $$v)
                                      },
                                      expression: "form.market_id"
                                    }
                                  },
                                  _vm._l(_vm.options.market, function(item) {
                                    return _c("el-option", {
                                      key: item.market_id,
                                      attrs: {
                                        value: item.market_id,
                                        label: item.market_name
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      clearable: "",
                                      multiple: "",
                                      "multiple-limit": 10,
                                      placeholder: "城市"
                                    },
                                    model: {
                                      value: _vm.form.city,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "city", $$v)
                                      },
                                      expression: "form.city"
                                    }
                                  },
                                  _vm._l(_vm.options.supply_city, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        value: item.key,
                                        label: item.label
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "代采组",
                                      clearable: "",
                                      filterable: ""
                                    },
                                    model: {
                                      value: _vm.form.pgid,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "pgid", $$v)
                                      },
                                      expression: "form.pgid"
                                    }
                                  },
                                  _vm._l(_vm.options.pg_group, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        value: item.value,
                                        label: item.label
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "代采员",
                                      filterable: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.pg_member_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "pg_member_id", $$v)
                                      },
                                      expression: "form.pg_member_id"
                                    }
                                  },
                                  _vm._l(_vm.options.pg_member, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        value: item.value,
                                        label: item.label
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "处理状态",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.verify_status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "verify_status", $$v)
                                      },
                                      expression: "form.verify_status"
                                    }
                                  },
                                  _vm._l(_vm.options.verify_status, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        value: item.value,
                                        label: item.label
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "反馈时间" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "起始日期",
                                    "end-placeholder": "截止日期"
                                  },
                                  model: {
                                    value: _vm.form.feedback_at,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "feedback_at", $$v)
                                    },
                                    expression: "form.feedback_at"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "包裹生成时间" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "起始日期",
                                    "end-placeholder": "截止日期"
                                  },
                                  model: {
                                    value: _vm.form.package_add_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "package_add_time",
                                        $$v
                                      )
                                    },
                                    expression: "form.package_add_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { "label-width": "0" } },
                              [
                                _c(
                                  "el-button",
                                  { on: { click: _vm.handleReset } },
                                  [_vm._v("重置")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { "label-width": "0" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.handleSearch }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  查询\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "div",
                  { staticStyle: { display: "inline-block", width: "60%" } },
                  [_vm._v("数据列表：")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      "text-align": "right",
                      width: "40%"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "success" },
                        on: { click: _vm.handleListExport }
                      },
                      [_vm._v("\n            导出列表")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "success" },
                        on: { click: _vm.handleDetailExport }
                      },
                      [_vm._v("\n            导出差异明细")]
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.tableLoading,
                        expression: "tableLoading"
                      }
                    ],
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      height: "600",
                      data: _vm.resData.list,
                      "tooltip-effect": "dark"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: "差异单号",
                        prop: "id",
                        width: "100",
                        fixed: "left"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: "商家名称",
                        prop: "supply_name",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { align: "center", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c("div", [
                                  _vm._v(_vm._s(row.billing_type_txt))
                                ]),
                                _vm._v(" "),
                                _c("div", [_vm._v(_vm._s(row.city_txt))]),
                                _vm._v(" "),
                                _c("div", [_vm._v(_vm._s(row.market_name))]),
                                _vm._v(" "),
                                _c("div", [_vm._v(_vm._s(row.pg_member_name))])
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("div", [_vm._v("开单方式/")]),
                            _vm._v(" "),
                            _c("div", [_vm._v("城市/")]),
                            _vm._v(" "),
                            _c("div", [_vm._v("市场/")]),
                            _vm._v(" "),
                            _c("div", [_vm._v("代采员/")])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "package_type_txt",
                        label: "包裹类型",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { align: "center", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c("div", [_vm._v(_vm._s(row.package_no))]),
                                _vm._v(" "),
                                _c("div", [_vm._v(_vm._s(row.spr_create_time))])
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("div", [_vm._v("包裹号/")]),
                            _vm._v(" "),
                            _c("div", [_vm._v("生成时间/")])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "total_amount_received",
                        label: "一手总收货件数",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "no_goods_nums",
                        label: "无数据件数（不含已入库）",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "stock_num",
                        label: "一手已入库件数（当前实时）",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "num",
                        label: "商家配货件数",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "check_sku_num",
                        label: "差异SKU个数",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { align: "center", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c("NumColorCell", {
                                  attrs: { num: row.check_goods_num }
                                })
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("div", [_vm._v("当前入库差异件数/")]),
                            _vm._v(" "),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content:
                                    "入库差异件数 = 一手已入库件数 - 商家配货件数",
                                  placement: "top-start"
                                }
                              },
                              [_c("i", { staticClass: "el-icon-question" })]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "verify_status_txt",
                        label: "处理状态",
                        width: "100"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { align: "center", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                row.user_name && row.created_at
                                  ? _c("div", [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(row.user_name) +
                                            "（爆版id：" +
                                            _vm._s(row.user_id) +
                                            "）"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(_vm._s(row.created_at))
                                      ])
                                    ])
                                  : _c("div", [_vm._v("-")])
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("div", [_vm._v("商家反馈人/")]),
                            _vm._v(" "),
                            _c("div", [_vm._v("时间")])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { align: "center", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                row.warehouse_admin_name &&
                                row.warehouse_verify_time_txt
                                  ? _c("div", [
                                      _c("div", [
                                        _vm._v(_vm._s(row.warehouse_admin_name))
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(row.warehouse_verify_time_txt)
                                        )
                                      ])
                                    ])
                                  : _c("div", [_vm._v("-")])
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("div", [_vm._v("仓库核实人/")]),
                            _vm._v(" "),
                            _c("div", [_vm._v("时间")])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        width: "100",
                        align: "center",
                        prop: "warehouse_time_consuming",
                        label: "仓库核实耗时"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { align: "center", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                row.supply_reason && row.supply_reason_time_txt
                                  ? _c("div", [
                                      _c("div", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(row.supply_reason) +
                                            "（爆版id：" +
                                            _vm._s(row.user_id) +
                                            "）\n                "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(row.supply_reason_time_txt)
                                        )
                                      ])
                                    ])
                                  : _c("div", [_vm._v("-")])
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("div", [_vm._v("商家申诉人/")]),
                            _vm._v(" "),
                            _c("div", [_vm._v("时间")])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { align: "center", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                row.complain_handling_admin_name &&
                                row.complain_handling_time_txt
                                  ? _c("div", [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            row.complain_handling_admin_name
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(row.complain_handling_time_txt)
                                        )
                                      ])
                                    ])
                                  : _c("div", [_vm._v("-")])
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("div", [_vm._v("申诉处理人/")]),
                            _vm._v(" "),
                            _c("div", [_vm._v("时间")])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        width: "100",
                        align: "center",
                        prop: "complain_handling_time_consuming",
                        label: "申诉处理耗时"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              row.complain_handling_time_consuming
                                ? _c("div", [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          row.complain_handling_time_consuming
                                        )
                                      )
                                    ])
                                  ])
                                : _c("div", [_vm._v("-")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "操作", fixed: "right" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleDetail(row)
                                    }
                                  }
                                },
                                [_vm._v("查看详情")]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "sizes,total, prev, pager, next,jumper ",
                        total: _vm.resData.count,
                        "page-size": _vm.form.page_size,
                        "page-sizes": [10, 20, 30, 50, 100]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "update:pageSize": function($event) {
                          return _vm.$set(_vm.form, "page_size", $event)
                        },
                        "update:page-size": function($event) {
                          return _vm.$set(_vm.form, "page_size", $event)
                        },
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.pageSizeChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f97b5f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f97b5f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/receiveGoods/StockVarianceProcess/index.vue
// module id = null
// module chunks = 